import React, { useState } from 'react';
import "./userManagement.scss";
import {
  MotifButton,
  MotifFormField,
  MotifSearch,
  MotifLabel,
  MotifInput,
  MotifIcon
} from "@ey-xd/motif-react";
import DialogActions from "@mui/material/DialogActions";



export const TableHeader = ({ onFilterTextBoxChanged, searchValue,tabName }) => {
  
  return (
    <div className='grid-header'>
      <div className='header-input'>
        <MotifFormField>
          <MotifSearch
            aria-label='Search'
            onChange={(e) => onFilterTextBoxChanged(e.target?.value)}
            placeholder='Search for...'
            value={searchValue}
          />
        </MotifFormField>
      </div>
    </div>
  );
};
